import { z } from "zod";
import { PublicIdSchema } from "./common";

export const BankAccountType = z.enum(["ordinary", "current"]);

const BankAccountFields = z.object({
  bank_name: z.string().trim().min(1),
  branch_name: z.string().trim().min(1),
  account_type: BankAccountType,
  account_number: z.string().trim().min(1),
  account_holder_name: z.string().trim().min(1),
});

const bankAccountFieldNames = [
  "bank_name",
  "branch_name",
  "account_type",
  "account_number",
  "account_holder_name",
] as const;

export const BankAccount = BankAccountFields.extend({
  id: PublicIdSchema,
  is_default: z.boolean(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

/**
 * デフォルト指定 (Issue #339 で複数指定可)。
 * create で省略した場合は「最初の 1 件のみ true」の既存挙動を維持する。
 */
export const CreateBankAccountInput = BankAccountFields.extend({
  is_default: z.boolean().optional(),
}).strict();

export const UpdateBankAccountInput = BankAccountFields.extend({
  is_default: z.boolean(),
})
  .partial()
  .strict()
  .refine(
    (input) =>
      bankAccountFieldNames.some((field) => input[field] !== undefined) ||
      input.is_default !== undefined,
    {
      message: "更新する口座情報を1項目以上指定してください",
    },
  );

export type BankAccountTypeDto = z.infer<typeof BankAccountType>;
export type BankAccountDto = z.infer<typeof BankAccount>;
export type CreateBankAccountInputDto = z.infer<typeof CreateBankAccountInput>;
export type UpdateBankAccountInputDto = z.infer<typeof UpdateBankAccountInput>;
